import {Upload} from './upload.model';

export class Setting {

    id: number;
    company_name: string;
    company_email: string;
    company_phone: string;
    company_address: string;
    company_shuttle_phone: string;
    text_page_home_title: string;
    text_page_home: string;
    text_page_home_sec: string;
    text_page_home_thr: string;
    text_page_coupon: string;
    text_page_book: string;
    text_email_header: string;
    text_email_footer: string;
    text_email_confirm: string;
    text_email_reconfirm: string;
    text_email_register: string;
    text_ad: string;
    is_cron: number;
    access_time_from: string;
    access_time_to: string;
    text_page_coupon_ewr?: string;
    text_notice_popup?: string;

    upload: Upload[];

    constructor(
        id: number,
        company_name: string, company_email: string, company_phone: string, company_address: string, company_shuttle_phone: string,
        text_page_home_title: string, text_page_home: string, text_page_home_sec: string, text_page_home_thr: string,
        text_page_coupon: string, text_page_book: string,
        text_email_header: string, text_email_footer: string,
        text_email_confirm: string, text_email_reconfirm: string, text_email_register: string,
        text_ad: string, is_cron: number,
        access_time_from: string, access_time_to: string,
        upload?: Upload[]) {
        this.id = id;
        this.company_name = company_name;
        this.company_email = company_email;
        this.company_phone = company_phone;
        this.company_address = company_address;
        this.company_shuttle_phone = company_shuttle_phone;
        this.text_page_home_title = text_page_home_title;
        this.text_page_home = text_page_home;
        this.text_page_home_sec = text_page_home_sec;
        this.text_page_home_thr = text_page_home_thr;
        this.text_page_coupon = text_page_coupon;
        this.text_page_book = text_page_book;
        this.text_email_header = text_email_header;
        this.text_email_footer = text_email_footer;
        this.text_email_confirm = text_email_confirm;
        this.text_email_reconfirm = text_email_reconfirm;
        this.text_email_register = text_email_register;
        this.text_ad = text_ad;
        this.is_cron = is_cron;
        this.access_time_from = access_time_from;
        this.access_time_to = access_time_to;
        this.upload = upload;
    }
}
